import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { __OCCURRED_INTEGRATION_PROPERTY } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
const makeIntegrationOccurredField = () => {
  return DSFieldRecord({
    displayType: DisplayTypes.DatetimeDisplayType,
    label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.occurredIntegration'),
    name: __OCCURRED_INTEGRATION_PROPERTY,
    type: DATE_TIME
  });
};
export default makeIntegrationOccurredField;